import { SlingoEvent, TestEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import '@pixi/graphics-extras';
import { Emitter, LinkedListContainer } from "@pixi/particle-emitter";
import { GlowFilter } from "pixi-filters";
import { GameEvent } from "../../../controller/event/GameEvent";
import { GameSlingoParticleProperties } from "../properties/GameSlingoParticlesProperties";
/**
 * Emits particles from the reel and ticket border
 */
export class GameSlingoParticles extends AbstractGameView {
    create() {
        super.create();
        Logger.addObjectRef(this);
        this.emitters = this.uiProperties.colours.map(colour => {
            const emitterContainer = this.addChild(new LinkedListContainer());
            emitterContainer.filters = [new GlowFilter({
                    ...this.uiProperties.glowProperties,
                    color: colour,
                })];
            const emitter = new Emitter(emitterContainer, this.uiProperties.getEmitterProperties());
            return emitter;
        });
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(TestEvent.SLINGO_1, () => this.playSlingos(1));
        this.registerGame(TestEvent.SLINGO_2, () => this.playSlingos(2));
        this.registerGame(TestEvent.SLINGO_3, () => this.playSlingos(3));
        this.registerGame(TestEvent.SLINGO_4, () => this.playSlingos(4));
        this.registerGame(SlingoEvent.SLINGO_WIN_ANIMATION, this.handleSlingoAnimation);
        this.registerGame(GameEvent.WIN_LINE_FIREWORKS_COMPLETE, () => this.playSlingos(2)); //we use the 2 for the win line
    }
    handleSlingoAnimation() {
        const slingos = this.model.getSlingosAwarded();
        this.playSlingos(slingos);
    }
    playSlingos(slingos) {
        this.emitters.forEach(emitter => {
            const multiplier = this.uiProperties.slingoAmountToSpawnChanceMultiplier[slingos - 1] ?? 1;
            emitter.spawnChance = GameSlingoParticleProperties.BASE_SPAWN_CHANCE * multiplier;
            emitter.emit = true;
        });
    }
}
//# sourceMappingURL=GameSlingoParticles.js.map